import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  newFeatureTitle: {
    id: 'adminPortal.productTours.newFeature.title',
    defaultMessage: 'New Feature',
    description: 'Title for new feature product tours.',
  },
  newFeatureNextButton: {
    id: 'adminPortal.productTours.newFeature.nextButton',
    defaultMessage: 'Next',
    description: 'Next button text for new feature product tours.',
  },
  newFeatureEndButton: {
    id: 'adminPortal.productTours.newFeature.endButton',
    defaultMessage: 'End',
    description: 'End button text for new feature product tours.',
  },
  newFeatureDismissButton: {
    id: 'adminPortal.productTours.newFeature.dismissButton',
    defaultMessage: 'Dismiss',
    description: 'Dismiss button text for new feature product tours.',
  },
  newFeatureBackButton: {
    id: 'adminPortal.productTours.newFeature.backButton',
    defaultMessage: 'Back',
    description: 'Back button text for new feature product tours.',
  },
  analyticsTourBody: {
    id: 'adminPortal.productTours.analyticsTour.body',
    defaultMessage: 'We redesigned our Analytics page! Same tools, now with more control over your data.',
    description: 'Body text for the analytics new feature tour.',
  },
  adminsTabNewFeatureTourBody: {
    id: 'adminPortal.productTours.adminsTabNewFeatureTour.body',
    defaultMessage: "We've recently added the ability for you to invite and manage your admins.",
    description: 'Body text for the admins tab new feature tour.',
  },
  browseAndRequestTourBody: {
    id: 'adminPortal.productTours.browseAndRequestTour.body',
    defaultMessage: "We've recently added a new feature that enables learners to browse for courses and request access. Continue to the settings page to learn more and configure access.",
    description: 'Body text for the browse and request new feature tour.',
  },
  highlightsTourBody: {
    id: 'adminPortal.productTours.highlightsTour.body',
    defaultMessage: "We've recently added a Highlights feature that allows you to create and recommend course collections to your learners.",
    description: 'Body text for the highlights new feature tour.',
  },
  learnerCreditTourBody: {
    id: 'adminPortal.productTours.learnerCreditTour.body',
    defaultMessage: "We've recently added a Learner Credit feature where you can review and manage your spend.",
    description: 'Body text for the learner credit new feature tour.',
  },
  learnerDetailPageTourBody: {
    id: 'adminPortal.productTours.learnerDetailPageTour.body',
    defaultMessage: "With the new learner profile feature, you can view a learner's enrollments, budgets, and groups all in one place. Access the learner profile by clicking on 'View more' on the People Management page.",
    description: 'Body text for the learner detail page new feature tour.',
  },
  portalAppearanceTourBody: {
    id: 'adminPortal.productTours.portalAppearanceTour.body',
    defaultMessage: 'With the new Portal Appearance feature, you can now upload a logo or select custom or theme colors to align the look and feel of your Admin and Learner Portals with your brand. Continue to Portal Appearance under Settings to learn more.',
    description: 'Body text for the portal appearance new feature tour.',
  },
  lprUpdateTourBody: {
    id: 'adminPortal.productTours.lprUpdateTour.body',
    defaultMessage: "We replaced {boldPassDate} and {boldProgressStatus} with {boldCourseProgress} and {boldCoursePassingGrade}. Don''t worry, you can still find that data in the CSV download.",
    description: 'Body text for the LPR report update tour.',
  },
  lprUpdateTourTitle: {
    id: 'adminPortal.productTours.lprUpdateTour.title',
    defaultMessage: 'Learner Progress Report Update',
    description: 'Title for the LPR report update tour.',
  },
});

export default messages;
